import React from "react";
import { Link as RouterLink, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAuth } from "../other/auth";
import { AppBar, Box, IconButton } from "@mui/material";
import NavBarOptions from "./NavBarOptions";

const NavBar = () => {
  const fullScreen = useSelector((state) => state.fullScreen);
  const location = useLocation();
  let auth = useAuth();
  const { playingMode } = useParams();

  return (
    <AppBar
      position="static"
      sx={{
        display: fullScreen ? "none" : "flex",
        height: 40, // Keeping the height compact
        borderBottom: "1px solid #000",
        borderTop: "1px solid #000",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "100%",
          padding: "0 16px",
        }}
      >
        <RouterLink to="/" style={{ textDecoration: "none", color: "inherit" }}>
          <img
            src="/img/icon.png"
            alt="icon"
            style={{ height: 40, verticalAlign: "middle" }} // Compact logo size
          />
        </RouterLink>
        <Box sx={{ display: "flex", gap: 1 }}>
          {auth.isAuth() && (
            <>
              <NavBarOptions />
              <IconButton
                component={RouterLink}
                to={{
                  pathname: `${location.pathname.split("?")[0]}search/`,
                  search: window.location.search,
                }}
              >
                <span class="material-symbols-outlined">search</span>
              </IconButton>

              <IconButton
                component={RouterLink}
                to={{
                  pathname: `${location.pathname}categories/`,
                  search: window.location.search,
                }}
              >
                <span class="material-symbols-outlined">clarify</span>
              </IconButton>

              <IconButton
                component={RouterLink}
                to={{
                  pathname: `${location.pathname}menu/`,
                  search: window.location.search,
                }}
              >
                <span class="material-symbols-outlined">menu</span>
              </IconButton>
            </>
          )}
        </Box>
      </Box>
    </AppBar>
  );
};

export default NavBar;
